module.exports = __webpack_public_path__ + "img/login_guide1.be30d55a.png";